import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CererePriorityService } from '../cerere-priority.service';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from "../../../../../environments/helper";
import { CererePriorityAddPayload } from '../cerere-priority.interface';

@Component({
    selector: 'app-add-cerere-priority',
    templateUrl: './add-cerere-priority.component.html',
    styleUrls: ['./add-cerere-priority.component.scss']
})
export class AddCererePriorityComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        color: new FormControl('', [Validators.required]),
        time: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required])
    });

    constructor(
        private dialogRef: MatDialogRef<AddCererePriorityComponent>,
        private cererePriorityService: CererePriorityService,
        private notificationService: NotificationService,
        private authService: AuthService) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token
            this.cererePriorityService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, color, time, slug } = this.form
            .value as CererePriorityAddPayload;

        const cererePriority: CererePriorityAddPayload = {
            name,
            color,
            time,
            slug
        };

        this.cererePriorityService
            .addCererePriority(cererePriority)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true })
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }
}
